import {BreakdownType, INDUSTRY_EVENTS} from './types';

// Re-export to keep organization consistent
// INDUSTRY_EVENTS could not be in this file bc of circular dependency
export {INDUSTRY_EVENTS};

export const IMMERSIVE_ONBOARDING_URL_PARAM = `immersive-onboarding`;

export const PROPERTIES: {[key in BreakdownType]: string} = {device_type: `Device Type`, country: `Country`, os: `OS`};

export const PROPERTY_BREAKDOWN_MAP: {[key in BreakdownType]: string[]} = {
  device_type: [`Mobile`, `Desktop`],
  country: [`US`, `Europe`],
  os: [`iOS`, `Android`],
};

export const SPRIG_QUALIFIER = `OnboardingFirstImpressionSprig`;

export const EVENT_INPUT_MAX = 6;

export const LEARN_MIXPANEL_YT_URL = `https://www.youtube.com/embed/Wpl0o0ipeB8?si=8P8Mw0SfyqVlkW6Q&autoplay=1`;

export const DEFAULT_INDUSTRY_KEY = `b2b`;
